import { PaginationItem, styled } from '@mui/material';
import { keyframes } from "@mui/system";

export const BoxAnimationStyle = styled("div", { shouldForwardProp: (prop) => prop !== "isOpen" })<{ isOpen?: boolean; }>(({ theme, isOpen }) => ({
    position: "relative",
    [theme.breakpoints.only('xl')]: {
        maxHeight: isOpen ? "805px" : "360px",
    },
    [theme.breakpoints.only('lg')]: {
        maxHeight: isOpen ? "805px" : "360px",
    },
    [theme.breakpoints.only('md')]: {
        maxHeight: isOpen ? "735px" : "205px",
    },
    [theme.breakpoints.down('md')]: {
        maxHeight: isOpen ? "630px" : "204px",
    },

    overflow: "hidden",
    transition: `max-height ${(isOpen ? "0.25s" : "0.15s")} ${(isOpen ? "ease-in" : "ease-out")}`
}));

export const PaginationItemStyle = styled(PaginationItem)(({ theme }) => ({
    borderRadius: "4px",
    "&.Mui-selected": {
        color: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "transparent",
        },
    }
}));